import axios from 'axios';

import {
	ADD_NEW_BRANDS,
	DELETE_BRANDS,
	GET_BRANDS
} from './types';

import { API_ENDPOINT } from '../../../index';

export const addNewBrands = (brands: string[]) => {
	return {
		type: ADD_NEW_BRANDS,
		brands,
	}
}

export const addNewBrandsAsync = (brands: string[]) => {
	return axios({
		url: `${API_ENDPOINT}/api/brands`,
		withCredentials: true,
		method: 'post',
		data: { brands }
	})
}

export const deleteBrand = ( brandId ) => {
	return {
		type: DELETE_BRANDS,
		payload: axios({
			withCredentials: true,
			method:'delete',
			url: `${API_ENDPOINT}/api/brands/${brandId}`,
		})
	}
}

export const getBrands = () => {
	return {
		type: GET_BRANDS,
		payload: axios({
			withCredentials: true,
			url: `${API_ENDPOINT}/api/brands`
		})
	}
}

export const _editBrand = ( brandId: string , updatedBrand) => {
	console.log(brandId, updatedBrand)
	return axios({
		// type: EDIT_BRAND,
		url: `${API_ENDPOINT}/api/brands/${brandId}`,
		withCredentials: true,
		method: 'post',
		data: {
			updatedBrand
		}
	})
}


// WEBPACK FOOTER //
// ./src/components/brands/actions/index.js